// import createPersistedState from 'vuex-persistedstate';
// import localforage from 'localforage';

import { store } from '../app';

const plugins = [
  ...store.plugins,
];

// if (typeof window !== 'undefined') {
//   plugins.push(
//     createPersistedState({
//       getState: key => localforage.getItem(key),
//       setState: (key, state) => localforage.setItem(key, state),
//     }),
//   );
// }

export default plugins;
